import React from "react";
import "./info.css";

function Info() {
  return (
    <section className="Hd0816ZAAmkl" aria-labelledby="contact-quarec-heading">
      <h1 id="contact-quarec-heading" className="BKS7615">
        Contact Quarec Resources
      </h1>
      <p className="jf0111654">
        For staffing, recruitment, payroll, international recruitment or career
        enquiries, contact our team with the role or service you are asking
        about, the relevant location and the requirements you already know.
        For a job enquiry, ask us to confirm current vacancy status before
        sharing sensitive documents. The scope and timing of each engagement
        are agreed with the relevant parties.
      </p>
    </section>
  );
}

export default Info;
